import Vue from 'vue'
import Router from 'vue-router'

import store from '../store';

import Top from '@/common/Top'
import Login from '@/common/Login'
import Register from '@/common/Register'
import ForgotPass from '@/common/ForgotPass'
import Footer from '@/common/Footer'

import Home from '@/components/Home'
import Index from '@/components/Index'

import NewHome from '@/newpage/NewHome'
import NewIndex from '@/newpage/NewIndex'

import VerifyEmail from '@/common/VerifyEmail'
import OtherLogin from '@/common/OtherLogin'
import Catalogue from '@/components/Catalogue'
import DownLoadpdf from '@/components/DownLoadpdf'
Vue.use(Router)

const router = new Router({
	routes: [
		{
			path:'/:code/Index',
			// path:'/:code',
			name:'NewHome',
			component:NewHome,
			redirect: '/'+store.state.rcode+'/'+store.state.language+'/Index',
			children: [
				{
					path: '/:code/:lang/AnimalLibrary',
					name: 'NewAnimalLibrary',
					component: () => import('../components/AnimalLibrary.vue'),
				},{
				path: '/:code/:lang/Index',
				name: 'NewIndex',
				component: NewIndex
			},{
				path: '/:code/Page/:page_id',
				name: 'ModePage',
				component: () => import('../newpage/ModePage.vue'),
			},{
				path: '/ChooseRegion',
				name: 'ChooseRegion',
				component: () => import('../newpage/ChooseRegion.vue'),
			},{
				path: '/:code/AboutShingHing',
				name: 'AboutShingHing',
				component: () => import('../newpage/AboutShingHing.vue'),
			},{
				path: '/:code/AboutWenno',
				name: 'AboutWenno',
				component: () => import('../newpage/AboutWenno.vue'),
			},{
				path: '/:code/Locations',
				name: 'Locations',
				component: () => import('../newpage/Locations.vue'),
			},{
				path: '/:code/CorporateResponsibility',
				name: 'CorporateResponsibility',
				component: () => import('../newpage/CorporateResponsibility.vue'),
			}]
		},
		{
			path: '/',
			name: 'Home',
			component: Home,
			redirect: '/Index',
			children: [{
				path: '/Index',
				name: 'Index',
				component: Index
			},{
				path: '/Sale',
				name: 'Sale',
				component: () => import('../components/Sale.vue'),
			},{
				path: '/AnimalLibrary',
				name: 'AnimalLibrary',
				component: () => import('../components/AnimalLibrary.vue'),
			},{
				path: '/AnimalDetail/:name',
				name: 'AnimalDetail',
				component: () => import('../components/AnimalDetail.vue'),
			},{
				path: '/Product',
				name: 'Product',
				component: () => import('../components/Product.vue'),
			},{
				path: '/Shop',
				name: 'Shop',
				component: () => import('../components/Shop.vue'),
			},{
				path: '/ProductDetail/:id',
				name: 'ProductDetail',
				component: () => import('../components/ProductDetail.vue'),
			},{
				path: '/ShopCart',
				name: 'ShopCart',
				component: () => import('../components/ShopCart.vue'),
			},{
				path: '/CheckOut',
				name: 'CheckOut',
				component: () => import('../components/CheckOut.vue'),
			},{
				path: '/payResult',
				name: 'payResult',
				component: () => import('../components/payResult.vue'),
			},{
				path: '/payme/:id',
				name: 'payme',
				component: () => import('../components/payme.vue'),
			},{
				path: '/paySuccess',
				name: 'paySuccess',
				component: () => import('../components/paySuccess.vue'),
			},{
				path: '/payFail',
				name: 'payFail',
				component: () => import('../components/payFail.vue'),
			},{
				path: '/OtherPay/:id',
				name: 'OtherPay',
				component: () => import('../components/OtherPay.vue'),
			},{
				path: '/OrderList',
				name: 'OrderList',
				component: () => import('../components/OrderList.vue'),
			},{
				path: '/OrderDetail/:id',
				name: 'OrderDetail',
				component: () => import('../components/OrderDetail.vue'),
			},{
				path: '/LineDetail/:line',
				name: 'LineDetail',
				component: () => import('../components/LineDetail.vue'),
			},{
				path: '/AccountDetail',
				name: 'AccountDetail',
				component: () => import('../components/AccountDetail.vue'),
			},{
				path: '/AddressBook',
				name: 'AddressBook',
				component: () => import('../components/AddressBook.vue'),
			},{
				path: '/PaymentMethod',
				name: 'PaymentMethod',
				component: () => import('../components/PaymentMethod.vue'),
			},{
				path: '/Preference',
				name: 'Preference',
				component: () => import('../components/Preference.vue'),
			},{
				path: '/About',
				name: 'About',
				component: () => import('../components/About.vue'),
      },{
        path: '/collections',
        name: 'ToyCollections',
        component: () => import('../components/ToyCollections.vue'),
			},{
				path: '/Blog',
				name: 'Blog',
				component: () => import('../components/Blog.vue'),
			},{
				path: '/BlogDetail/:id',
				name: 'BlogDetail',
				component: () => import('../components/BlogDetail.vue'),
			},{
				path: '/T&C',
				name: 'T&C',
				component: () => import('../components/T&C.vue'),
			},{
				path: '/PrivacyPolicy',
				name: 'PrivacyPolicy',
				component: () => import('../components/PrivacyPolicy'),
			},{
				path: '/DeliveryService',
				name: 'DeliveryService',
				component: () => import('../components/DeliveryService'),
			},{
				path: '/ContactUs',
				name: 'ContactUs',
				component: () => import('../components/ContactUs'),
			}]
		},{
			path:'/VerifyEmail/:id/:expires/:signature',
			name:'VerifyEmail',
			component:VerifyEmail
		},{
			path:'/OtherLogin',
			name:'OtherLogin',
			component:OtherLogin
		},{
			path:'/Catalogue',
			name:'Catalogue',
			component:Catalogue
		},
		{
			path:'/DownLoadpdf',
			name:'DownLoadpdf',
			component:DownLoadpdf
		},
		{
			path:'/StoryBook/AfricanLion',
			name:'AfricanLion',
			component: () => import('../story/AfricanLion.vue'),
			meta:{
				title: 'African Lion'
			}
		},{
			path:'/StoryBook/OceanSunfish',
			name:'OceanSunfish',
			component: () => import('../story/OceanSunfish.vue'),
			meta:{
				title: 'Ocean Sunfish'
			}
		},{
			path:'/StoryBook/BrownBear',
			name:'BrownBear',
			component: () => import('../story/BrownBear.vue'),
			meta:{
				title: 'Brown Bear'
			}
		},{
			path:'/StoryBook/EmperorPenguin',
			name:'EmperorPenguin',
			component: () => import('../story/EmperorPenguin.vue'),
			meta:{
				title: 'Emperor Penguin'
			}
		},{
			path:'/hole/Lion',
			name:'Lion',
			component: () => import('../hole/Lion.vue'),
			meta:{
				title: 'Lion Hologram'
			}
		},{
			path:'/hole/Elephant',
			name:'Elephant',
			component: () => import('../hole/Elephant.vue'),
			meta:{
				title: 'Elephant Hologram'
			}
		},{
			path:'/hole/Giraffe',
			name:'Giraffe',
			component: () => import('../hole/Giraffe.vue'),
			meta:{
				title: 'Giraffe Hologram'
			}
		},{
			path:'/hole/Leopard',
			name:'Leopard',
			component: () => import('../hole/Leopard.vue'),
			meta:{
				title: 'Leopard Hologram'
			}
		},{
			path:'/hole/Rhino',
			name:'Rhino',
			component: () => import('../hole/Rhino.vue'),
			meta:{
				title: 'Rhino Hologram'
			}
		},{
			path:'/hole/Zebra',
			name:'Zebra',
			component: () => import('../hole/Zebra.vue'),
			meta:{
				title: 'Zebra Hologram'
			}
		},{
			path:'/hole/VideoDtl',
			name:'VideoDtl',
			component: () => import('../hole/VideoDtl.vue'),
			meta:{
				title: 'VideoDtl'
			}
		},


	],
	scrollBehavior: () => ({ y: 0 }),
})

//push
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

window.dataLayer = window.dataLayer || []
function gtag () {
	window.dataLayer.push(arguments);
}

router.afterEach((to, from) => {
	if(to.meta.title) {
		document.title = to.meta.title
	}
	gtag('config', 'UA-177277299-1', {
		page_title: to.name,
		page_path: to.fullPath,
		// page_location: location
	})
})

router.beforeEach((to, from, next) => {
	let link = window.location.href.split('#')[0];
	if(link === 'https://www.thmgmt.net/'){
	    if (to.path === '/Index') {
	        return next({ path: '/'+store.state.rcode+'/Index' })
	    } else {
	        next();
	    }
	}else{
		next();
	}
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js